var _g, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _g2, _path2, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvailableTickets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 154,
    viewBox: "0 0 135 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4871 25.5649L81.1889 18.1202C79.3274 14.8961 74.639 14.0858 70.7701 16.3195L14.4953 48.8098C10.6264 51.0435 9.00217 55.4594 10.8805 58.7127L15.1787 66.1574C16.3463 68.1798 18.6577 69.5028 21.3447 69.202C24.1528 68.9485 26.7468 70.0301 28.0329 72.2577C29.319 74.4852 28.9404 77.3221 27.283 79.5687C25.7311 81.7543 25.686 84.4378 26.8536 86.4601L31.1518 93.9048C33.0132 97.1289 37.7016 97.9392 41.5705 95.7055L97.8454 63.2152C101.714 60.9815 103.357 56.516 101.495 53.292L97.1971 45.8473C96.0295 43.8249 93.6829 42.5223 91.0142 42.7734C88.223 43.0562 85.5938 41.9949 84.3077 39.7674C83.0217 37.5398 83.4172 34.7322 85.0577 32.4564C86.6095 30.2708 86.6547 27.5873 85.4871 25.5649V25.5649Z",
    fill: "#03CAA5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5761 46.896C49.1733 45.0009 51.4309 43.6974 52.8707 44.9939L56.2855 48.0685C56.9294 48.6483 57.8733 48.7475 58.6237 48.3143L62.6031 46.0168C64.281 45.0481 66.2183 46.7924 65.4302 48.5623L63.5613 52.7601C63.2088 53.5516 63.4062 54.4801 64.0501 55.0598L67.4649 58.1345C68.9047 59.4309 67.8444 61.8124 65.9175 61.6099L61.3477 61.1296C60.486 61.039 59.664 61.5136 59.3115 62.3051L57.4426 66.5029C56.6545 68.2728 54.062 68.0004 53.6592 66.1053L52.7038 61.6106C52.5237 60.7631 51.8183 60.128 50.9566 60.0374L46.3867 59.5571C44.4599 59.3546 43.9179 56.8047 45.5958 55.836L49.5752 53.5385C50.3256 53.1052 50.7116 52.2381 50.5315 51.3906L49.5761 46.896Z",
    fill: "#D9F7F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.875,
    y: 49.7617,
    width: 2.50696,
    height: 2.50696,
    transform: "rotate(-30 21.875 49.7617)",
    fill: "#D9F7F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.0352,
    y: 23.6875,
    width: 2.50697,
    height: 2.50697,
    transform: "rotate(-30 67.0352 23.6875)",
    fill: "#D9F7F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.3828,
    y: 55.8398,
    width: 2.50696,
    height: 2.50697,
    transform: "rotate(-30 25.3828 55.8398)",
    fill: "#D9F7F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70.543,
    y: 29.7656,
    width: 2.50695,
    height: 2.50696,
    transform: "rotate(-30 70.543 29.7656)",
    fill: "#D9F7F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8945,
    y: 61.918,
    width: 2.50697,
    height: 2.50695,
    transform: "rotate(-30 28.8945 61.918)",
    fill: "#D9F7F2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74.0508,
    y: 35.8477,
    width: 2.50696,
    height: 2.50697,
    transform: "rotate(-30 74.0508 35.8477)",
    fill: "#D9F7F2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4023,
    y: 67.9961,
    width: 2.50697,
    height: 2.50697,
    transform: "rotate(-30 32.4023 67.9961)",
    fill: "#D9F7F2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5625,
    y: 41.9258,
    width: 2.50695,
    height: 2.50696,
    transform: "rotate(-30 77.5625 41.9258)",
    fill: "#D9F7F2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 35.9141,
    y: 74.0781,
    width: 2.50696,
    height: 2.50696,
    transform: "rotate(-30 35.9141 74.0781)",
    fill: "#D9F7F2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 81.0742,
    y: 48.0039,
    width: 2.50697,
    height: 2.50697,
    transform: "rotate(-30 81.0742 48.0039)",
    fill: "#D9F7F2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 39.4219,
    y: 80.1562,
    width: 2.50697,
    height: 2.50697,
    transform: "rotate(-30 39.4219 80.1562)",
    fill: "#D9F7F2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 84.582,
    y: 54.082,
    width: 2.50697,
    height: 2.50697,
    transform: "rotate(-30 84.582 54.082)",
    fill: "#D9F7F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 42.9336,
    y: 86.2344,
    width: 2.50697,
    height: 2.50696,
    transform: "rotate(-30 42.9336 86.2344)",
    fill: "#D9F7F2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 88.0898,
    y: 60.1641,
    width: 2.50698,
    height: 2.50696,
    transform: "rotate(-30 88.0898 60.1641)",
    fill: "#D9F7F2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.003 86.6526V78.0484C112.003 74.3222 108.344 71.2734 103.873 71.2734H38.8331C34.3616 71.2734 30.7438 74.2883 30.7438 78.0484V86.6526C30.7438 88.9899 32.0852 91.2934 34.5648 92.3774C37.1258 93.563 38.8331 95.7988 38.8331 98.3733C38.8331 100.948 37.0851 103.217 34.5242 104.335C32.0852 105.453 30.7031 107.757 30.7031 110.094V118.698C30.7031 122.424 34.3616 125.473 38.8331 125.473H103.873C108.344 125.473 112.003 122.424 112.003 118.698V110.094C112.003 107.757 110.62 105.453 108.181 104.335C105.621 103.183 103.873 100.948 103.873 98.3733C103.873 95.7988 105.621 93.563 108.181 92.4113C110.62 91.2934 112.003 88.9899 112.003 86.6526V86.6526Z",
    fill: "#03CAA5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2028 87.1627C70.8015 85.3201 73.4083 85.3201 74.007 87.1627L75.4304 91.5434C75.6981 92.3674 76.466 92.9253 77.3325 92.9253H81.9386C83.876 92.9253 84.6816 95.4046 83.1142 96.5434L79.3877 99.2508C78.6868 99.7601 78.3934 100.663 78.6612 101.487L80.0846 105.868C80.6833 107.71 78.5743 109.242 77.0069 108.104L73.2805 105.396C72.5795 104.887 71.6303 104.887 70.9293 105.396L67.2029 108.104C65.6355 109.242 63.5265 107.71 64.1252 105.868L65.5486 101.487C65.8163 100.663 65.523 99.7601 64.822 99.2508L61.0956 96.5434C59.5282 95.4046 60.3337 92.9253 62.2712 92.9253H66.8773C67.7437 92.9253 68.5117 92.3674 68.7794 91.5434L70.2028 87.1627Z",
    fill: "#D9F7F2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7539,
    y: 75.7891,
    width: 2.50924,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9492,
    y: 75.7891,
    width: 2.50924,
    height: 2.50925,
    fill: "#D9F7F2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7539,
    y: 82.8164,
    width: 2.50924,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9492,
    y: 82.8164,
    width: 2.50922,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7539,
    y: 89.8398,
    width: 2.50924,
    height: 2.50923,
    fill: "#D9F7F2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9453,
    y: 89.8398,
    width: 2.50924,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7539,
    y: 96.8672,
    width: 2.50924,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9492,
    y: 96.8672,
    width: 2.50923,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7539,
    y: 103.891,
    width: 2.50924,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9453,
    y: 103.895,
    width: 2.50925,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7539,
    y: 110.918,
    width: 2.50924,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9492,
    y: 110.918,
    width: 2.50924,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7539,
    y: 117.945,
    width: 2.50924,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 96.9453,
    y: 117.945,
    width: 2.50925,
    height: 2.50924,
    fill: "#D9F7F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 2.46094,
    y: 8.00781,
    width: 108.419,
    height: 99.7585,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd",
    x: 25.7031,
    y: 67.0234,
    width: 92.2994,
    height: 66.4496,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableTickets);
export default __webpack_public_path__ + "static/media/available-tickets.5ad2eb0cbfecf8b0277a09775722cba9.svg";
export { ForwardRef as ReactComponent };